import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// ----------------------------------------------------------------------

export default function ScrollToTop() {
  const { hash, pathname, search } = useLocation();

  useEffect(() => {
    const animationFrame = window.requestAnimationFrame(() => {
      const target = hash && document.getElementById(hash.slice(1));
      if (target) {
        target.scrollIntoView({ behavior: 'auto' });
        return;
      }
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    });

    return () => window.cancelAnimationFrame(animationFrame);
  }, [hash, pathname, search]);

  return null;
}
